// MyProperties.jsx
import React, { useEffect, useState } from "react";
import s from "../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import CardComponent from "../../../shared/components/Card/CardComponent";
import Filter from "../../../shared/components/Filter/ui/Filter";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SkipPrevious from "@mui/icons-material/SkipPrevious";
import { searchProperties, clearResults } from "../../../shared/components/Filter/model/filterSlice";
import { toast } from "react-toastify";
import { endpointMap } from "../../../data/Fields";
import {fetchProperties} from "../../General/model/propertiesSlice";

const buttons = [
    { title: "Срочный вариант", background: "rgba(245, 212, 221, 1)", color: "rgba(218, 86, 119, 1)" },
    { title: "Эксклюзивный договор", background: "rgba(251, 236, 205, 1)", color: "rgba(241, 179, 55, 1)" },
    { title: "Выкупной вариант", background: "rgba(208, 228, 247, 1)", color: "rgba(67, 148, 224, 1)" },
    { title: "Без рекламы", background: "rgba(209, 239, 206, 1)", color: "rgba(73, 191, 62, 1)" },
];

const MyProperties = () => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.refresh_token);
    const agent_id = useSelector((state) => state.auth.agent_id);
    const { data, page, pageSize, total, totalPages, status } = useSelector(
        (state) => state.properties
    );
    const { loading, results } = useSelector((state) => state.filter);
    const [currentPage, setCurrentPage] = useState(1);

    const [searchParams, setSearchParams] = useState({});


    useEffect(() => {
        dispatch(fetchProperties({ token, agent_id, page: currentPage, pageSize, ...searchParams  }));
    }, [dispatch, token, currentPage, pageSize, searchParams]);


    const onSubmit = async (formData) => {
        const params = {};
        Object.entries(formData).forEach(([key, value]) => {
            if (value) {
                if (key === "property_type") {
                    if (value === "Дома и участки") {
                        params[key] = "дома";
                    } else if (endpointMap[value]) {
                        params[key] = value.toLowerCase();
                    }
                } else if (key === "agents") {
                    params["agent_id"] = value;
                } else if (key === "property_condition") {
                    params[key] = value.toLowerCase();
                } else if (key === "transaction_type") {
                    params[key] = value.toLowerCase();
                } else if (key === "land_type") {
                    params[key] = value.toLowerCase();
                } else {
                    params[key] = value;
                }
            }
        });
        console.log(params, 'params');

        if (!searchParams.agent_id) {
            searchParams.agent_id = agent_id;
        }

        setSearchParams(params);
        setCurrentPage(1);


        dispatch(fetchProperties({ token, agent_id, page: 1, pageSize, ...params }))
            .unwrap()
            .then((result) => {
                if (!result.data || result.data.length === 0) {
                    toast.info("Нет данных по вашему запросу.");
                } else {
                    toast.success("Поиск завершен!");
                }
            })
            .catch((error) => toast.error(error));

    };

    const onClear = () => {
        dispatch(clearResults());
        dispatch(fetchProperties({ token, agent_id, page: 1, pageSize }));
        toast.info("Фильтры сброшены. Показаны ваши объекты.");
        setCurrentPage(1);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        dispatch(fetchProperties({ token, agent_id, page: newPage, pageSize, ...searchParams }));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };



    return (
        <div className="container">
            <Filter onSubmit={onSubmit} results={results} loading={loading} hideAgents onClear={onClear}/>
            <h1
                style={{
                    color: "rgba(19, 19, 19, 0.7)",
                    fontSize: 16,
                    fontWeight: 500,
                    marginBottom: 30,
                    textAlign: "center",
                }}
            >
                Показано {(currentPage - 1) * pageSize + 1} –{" "}
                {Math.min(currentPage * pageSize, total)} из {total}
            </h1>
            <div className={s.cardBlock}>
                {status === "loading" ? (
                    <div className={s.loadingWrapper}>
                        <div className="loader"></div>
                    </div>
                ) : data && data.length > 0 ? (
                    data.map((item) => (
                        <CardComponent key={item.id} item={item} buttons={buttons}/>
                    ))
                ) : (
                    <p>Нет данных</p>
                )}
            </div>


            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    gap: 20,
                    marginTop: "20px",
                }}
            >
                <button
                    style={{cursor: "pointer"}}
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                >
                    <SkipPrevious/>
                </button>
                <span>
          {currentPage} из {totalPages}
        </span>
                <button
                    style={{cursor: "pointer"}}
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                >
                    <SkipNextIcon/>
                </button>
            </div>
        </div>
    );
};

export default MyProperties;
